import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { AdapterApiService } from "../_adapter";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import * as Routes from "@/router/routerNames";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-identification-legal',
  setup(__props) {



const router = useRouter();
const adapterUser = AdapterApiService.getInstance();
const isVisible = ref(false);

// когда переходим сразу после регистрации
// и данные ще не заполнены то false
const isContinue = ref(false);

onMounted(async () => {
	isContinue.value = !!adapterUser.userInfo.value.FirstName&&!!adapterUser.userInfo.value.LastName
	isVisible.value = isContinue.value;
});

function onContinue() {
	isContinue.value = true;
	router.push({ name: "profile-identification-legal" });
}


return (_ctx: any,_cache: any) => {
  const _component_identification_start = _resolveComponent("identification-start")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!isContinue.value)
      ? (_openBlock(), _createBlock(_component_identification_start, {
          key: 0,
          onContinue: onContinue
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})